<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="90%"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <Main ref="main" @checkbox-change="(e) => (checkedRow = e)" />
    <span slot="footer">
      <el-button size="small" class="mr-2" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-badge :value="checkCount">
        <el-button
          type="primary"
          size="small"
          @click="confirm()"
          :disabled="isEmpty"
        >
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </el-badge>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  data() {
    return {
      checkedRow: [],
    }
  },
  computed: {
    isEmpty() {
      return !this.checkedRow || !this.checkedRow.length
    },
    checkCount() {
      if (this.isEmpty) return 0
      return this.checkedRow.length
    },
  },
  methods: {
    confirm() {
      if (this.isEmpty) return
      this.$emit('confirm', this.checkedRow)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      this.checkedRow = []
    },
  },
}
</script>
